import React from 'react';
import Cards from '../Cards';

const Services = () => {
  return (
    <div>
      <Cards/>
      
    </div>
  );
};

export default Services;
